import { create } from 'zustand';

export interface IHeatmapModalData {
  open: boolean;
  params: string;
}
export interface IHeatmapModalStore {
  data?: IHeatmapModalData;
  setOpenModal: (data: IHeatmapModalData) => void;
}

export const useHeatmapModalStore = create<IHeatmapModalStore>()((set) => ({
  data: undefined,

  setOpenModal: (data) => set({ data }),
  resetOpenModal: () => set({ data: undefined }),
}));
